import styled, { css } from 'styled-components'
import { color, size, fontWeight, fontSize } from 'ui/themes/utils'

import I from 'ui/elements/I'

export const Location = styled.div`
  width: 100%;

  .Select__control {
    height: auto !important;
    min-height: 56px !important;
  }

  .Select__indicators {
    height: auto;
    min-height: 56px;
  }

  .Select__single-value {
    width: 100%;

    ${I} {
      /* It doesn't recognize value from fontSize util here */
      font-size: 16px !important;
    }
  }
`

export const Control = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr auto;
  align-items: center;
  gap: ${size('margin', 'sm')};
`

export const Title = styled.p`
  color: ${color('Text/Primary')};

  font-size: ${fontSize('md')};
  font-weight: ${fontWeight('bold')};

  ${({ isOption }) =>
    isOption &&
    css`
      font-weight: ${fontWeight('semibold')};
    `}

  margin: 0;
`

export const Subtitle = styled(Title)`
  font-weight: ${fontWeight('normal')};

  ${({ isOption }) =>
    isOption &&
    css`
      color: ${color('Text/Secondary')};

      font-size: ${fontSize('sm')};
    `}
`

export const Option = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: ${size('margin', 'sm')};
`
